import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AuditoriaLayer from "../components/AuditoriaLayer";
import { useTranslation } from "../i18n/I18nContext";

const AuditoriaPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("auditoria.breadcrumb")} />
      <AuditoriaLayer />
    </MasterLayout>
  );
};

export default AuditoriaPage;
